import React, { Component } from 'react'
import { Row, Col, Tooltip } from 'reactstrap';

class MindPatterns extends Component {

  constructor(props) {
    super(props)

    this.state = {
      tooltipOpen: {}
    }

    this.toggleTool = this.toggleTool.bind(this);
  }

  toggleTool = (id) => {
    this.setState((prevState) => ({
      tooltipOpen: {
        ...prevState.tooltipOpen,
        [id]: !prevState.tooltipOpen[id],
      },
    }));
  };

  render() {
    const { tooltipOpen } = this.state
    const { team_report, areas } = this.props;

    let mind_patterns = null

    if (team_report && team_report.mind_pattern && areas?.items) {
      mind_patterns = team_report.mind_pattern.split("").map((mp, k) => {
        let mPattern = areas.items.find((item) => item.code === mp )

        if(!mPattern) return null;

        return <div key={mp + k} className={`text-center item-mind-patterns item-mind-patterns-${mPattern.name.toLowerCase()}`}>
          <div>
            <h4 className='font-weight-bold' id={`tooltip-${mPattern.name}`}>{team_report[`mind_pattern_p${(k + 1)}`]}%
            <i className='text-muted ml-2 d-inline-block'>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="d-block bi bi-info-circle-fill" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                </svg>
            </i>
            </h4>
            <Tooltip placement="right" isOpen={tooltipOpen[mPattern.name]} target={`tooltip-${mPattern.name}`} toggle={() => this.toggleTool(mPattern.name)}>
                {mp === 'A' && <span>Percentage of team members whose Mind Pattern has Auditory as Focused attention (AVK or AKV)</span>}
                {mp === 'V' && <span>Percentage of team members whose Mind Pattern has Visual as Focused attention (VAK or VKA)</span>}
                {mp === 'K' && <span>Percentage of team members whose Mind Pattern has Kinesthetic as Focused attention (KAV or KVA)</span>}
            </Tooltip>
            <div className={`mb-2 rounded-circle item-mind-pattern-icon p-1 bg-${mPattern.name.toLowerCase()}`}>
              <img src={mPattern.icon} alt={mPattern.name} width={40} height={'auto'} className={`${mPattern.name.toLowerCase() !== 'auditory' ? 'icon-inverse' : ''}`}/>
            </div>
            <p className="font-weight-semibold">{mPattern.name}</p>
          </div>
        </div>

      })
    }

    return (
      <>
        {/* <MindPatternsFullReport /> */}

        <div className='rounded border p-3'>
          <Row noGutters className="mind-patterns-tab align-items-center pt-2">
            <Col md={{ size: 4 }} className='mx-auto'>
              <div className="d-flex align-items-start justify-content-between mb-2">
                {team_report.mind_pattern ? mind_patterns
                  :
                  <>
                    {areas.items.map((area) => (
                      <div key={area.id} className={`text-center item-mind-patterns item-mind-patterns-${area.name.toLowerCase()}`}>
                        <div>
                          <h4 className='font-weight-bold' id={`tooltip-${area.name}`}>0%
                          <i className='text-muted ml-2 d-inline-block'>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="d-block bi bi-info-circle-fill" viewBox="0 0 16 16">
                                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
                              </svg>
                          </i>
                          </h4>
                          <Tooltip placement="right" isOpen={tooltipOpen[area.name]} target={`tooltip-${area.name}`} toggle={() => this.toggleTool(area.name)}>
                              {area.code === 'A' && <span>Percentage of team members whose Mind Pattern has Auditory as Focused attention (AVK or AKV)</span>}
                              {area.code === 'V' && <span>Percentage of team members whose Mind Pattern has Visual as Focused attention (VAK or VKA)</span>}
                              {area.code === 'K' && <span>Percentage of team members whose Mind Pattern has Kinesthetic as Focused attention (KAV or KVA)</span>}
                          </Tooltip>
                          <div className={`mb-2 rounded-circle item-mind-pattern-icon p-1 bg-${area.name.toLowerCase()}`}>
                            <img src={area.icon} alt={area.name} width={40} height={'auto'} className={`${area.name.toLowerCase() !== 'auditory' ? 'icon-inverse' : ''}`}/>
                          </div>
                          <p className="font-weight-semibold">{area.name}</p>
                        </div>
                      </div>
                    ))}
                  </>
                }
              </div>
            </Col>
            <Col xs="12" className='text-center'><p className='text-muted mb-0'><i>Note that percentages only reflect team members who have completed each assessment.</i></p></Col>
          </Row>
        </div>

      </>
    )
  }
}

export default MindPatterns;
